module.exports = __webpack_public_path__ + "img/bank.8fbf206a.webp";